module.exports = __webpack_public_path__ + "static/Ipad2-365d406c577e6d5d8766c5f0d41c9b3c.png";